<template>
  <div>
    <Appbar />
    <transition name="fade" mode="out-in">
      <router-view
          :style="{ 'visibility': renderFcp ? 'visible':'hidden' }"
          class="header-space-tcdc"
          style="min-height: 284px;"
      ></router-view>
    </transition>
    <!-- The content above stays hidden until the branch/service data is in, and
         so must the footer: until then it is the only visible thing on the page,
         sitting right under the header, and it is thrown off-screen the moment the
         content renders - one of the largest layout shifts on the site. Hiding it
         (not removing it) keeps its layout box, so it only becomes visible once it
         is already at its final position. -->
    <Footer :style="{ 'visibility': renderFcp ? 'visible':'hidden' }" />
  </div>
</template>
<script>
import Appbar from "../components/headers/Appbar";
import Footer from "../components/footers/Footer";
import {defaultDescription, defaultImage, defaultKeyword, defaultTitle, eventBus, setMetaTags} from "@/util/Constants";

export default {
  components: {
    Appbar,
    Footer
  },
  data: () => ({
    renderFcp: false
  }),
  created() {
    eventBus.$on('renderFcp', () => {
      this.renderFcp = true
    })
    if (this.$route.path === "/") {
      this.$router.push("/landing");
    }
  },
  computed: {
    routePath: function () {
      return this.$route.path
    }
  },
  watch: {
    routePath: function () {
      let title = defaultTitle
      let description = defaultDescription
      let keyword = defaultKeyword

      switch (this.$route.path) {
        case '/th/all/service/resource-center/article':
        case '/en/all/service/resource-center/article':
          title = "บทความ (Article) อัพเดทเรื่องราวของธุรกิจสร้างสรรค์ นวัตกรรมวัสดุ การออกแบบ";
          description = "บทความด้านความคิดสร้างสรรค์และการออกแบบ ไอเดียในการคิด ผลิต ขาย เทรนด์ธุรกิจ นวัตกรรมวัสดุ เทคโนโลยี เพื่อพัฒนาผลิตภัณฑ์และธุรกิจสร้างสรรค์";
          keyword = "บทความเศรษฐกิจสร้างสรรค์, บทความธุรกิจสร้างสรรค์, ความคิดสร้างสรรค์, creative economy, นักสร้างสรรค์, ผู้ประกอบการสร้างสรรค์, พื้นที่สร้างสรรค์, Business, Industrial, Design, Creativity, Material, Innovation, Creative Economy, Creativity, Trend, Creative City, Creative Startup, Service Design, Design Thinking";
          break;

        case '/th/all/service/resource-center/e-book':
        case '/en/all/service/resource-center/e-book':
          title = "E-book องค์ความรู้ด้านธุรกิจสร้างสรรค์ นวัตกรรมวัสดุ การออกแบบ เทรนด์โลก";
          description = "TCDC รวบรวมองค์ความรู้เป็นรูปเล่ม E-book ด้านความคิดสร้างสรรค์ สร้างไอเดียในการคิด ผลิต ขาย พร้อมเทรนด์ธุรกิจ นวัตกรรมวัสดุ เทคโนโลยีเพื่อพัฒนาผลิตภัณฑ์และพัฒนาธุรกิจสร้างสรรค์";
          keyword = "อีบุค, E-book, ธุรกิจสร้างสรรค์, ความคิดสร้างสรรค์, creative economy, นักสร้างสรรค์, ผู้ประกอบการสร้างสรรค์, เศรษฐกิจสร้างสรรค์, พื้นที่สร้างสรรค์, การออกแบบบริการ, การออกแบบ, Trend, Business, Industrial, Design, Creativity, Material, Innovation, Creative Economy, Creativity, Trend, Creative City, Creative Startup, Service Design, Design Thinking";
          break;

        case '/th/all/service/resource-center/online-exhibition':
        case '/en/all/service/resource-center/online-exhibition':
          title = "นิทรรศการออนไลน์ Online Exhibition";
          description = "TCDC จัดทํานิทรรศการออนไลน์กระตุ้นความคิดสร้างสรรค์ สร้างไอเดียในการคิด ผลิต ขาย ให้กับนักสร้างสรรค์";
          keyword = "นิทรรศการออนไลน์, Online Exhibition, ธุรกิจสร้างสรรค์, ความคิดสร้างสรรค์, creative economy, นักสร้างสรรค์, ผู้ประกอบการสร้างสรรค์, เศรษฐกิจสร้างสรรค์, พื้นที่สร้างสรรค์, Trend, Creative Business, Industrial, Design, Creativity, Material, Innovation, Creative Economy, Creativity, Trend, Creative City, Creative Startup";
          break;

        case '/th/all/service/resource-center/design-world-calendar':
        case '/en/all/service/resource-center/design-world-calendar':
          title = "Design World Calendar ปฏิทินกิจกรรมและงานดีไซน์จากทั่วโลก";
          description = "TCDC คัดสรรคกิจกรรมงานดีไซน์วีค งานออกแบบ งานประกวด งานแสดงสินค้าธุรกิจสร้างสรรค์จากทั่วโลก";
          keyword = "ดีไซน์วีค, ปฏิทินกิจกรรม, ปฏิทินงานออกแบบ, ความคิดสร้างสรรค์, งานแสดงสินค้า, ธุรกิจสร้างสรรค์, Design Week, Design event";
          break;

        case '/faqs':
          title = "FAQ คําถามที่พบบ่อย";
          description = "TCDC คัดเลือกคําถามที่พบบ่อยเกี่ยวกับการสมัครสมาชิก การเข้าใช้บริการห้องสมุด";
          keyword = "สมัครสมาชิก TCDC, บริการห้องสมุด, ฐานข้อมูลออนไลน์, ห้องสมุด TCDC, สมาชิก TCDC";
          break;

        case '/th/all/about/news':
        case '/en/all/about/news':
          title = "News ข่าวประชาสัมพันธ์";
          description = "อัพเดทข่าวประชาสัมพันธ์ TCDC ทุกสาขา";
          keyword = "ข่าวสาร, ข่าวประสัมพันธ์ TCDC, ข่าวสาร TCDC";
          break;

        case '/th/tcdc-bangkok/about/news':
        case '/en/tcdc-bangkok/about/news':
          title = "News ข่าวประชาสัมพันธ์ TCDC Bangkok";
          description = "อัพเดทข่าวประชาสัมพันธ์ TCDC กรุงเทพฯ";
          keyword = "ข่าวสาร, ข่าวประสัมพันธ์ TCDC Bangkok, ข่าวประสัมพันธ์ TCDC กรุงเทพฯ, ข่าวสาร TCDC Bangkok";
          break;

        case '/th/tcdc-chiangmai/about/news':
        case '/en/tcdc-chiangmai/about/news':
          title = "News ข่าวประชาสัมพันธ์ TCDC Chiangmai";
          description = "อัพเดทข่าวประชาสัมพันธ์ TCDC เชียงใหม่";
          keyword = "ข่าวสาร, ข่าวประสัมพันธ์ TCDC Chiangmai, ข่าวประสัมพันธ์ TCDC เชียงใหม่, ข่าวสาร TCDC Chiangmai";
          break;

        case '/th/tcdc-khonkaen/about/news':
        case '/en/tcdc-khonkaen/about/news':
          title = "News ข่าวประชาสัมพันธ์ TCDC Khon Kaen";
          description = "อัพเดทข่าวประชาสัมพันธ์ TCDC ขอนแก่น";
          keyword = "ข่าวสาร, ข่าวประสัมพันธ์ TCDC Khon Kaen, ข่าวประสัมพันธ์ TCDC ขอนแก่น, ข่าวสาร TCDC Khon Kaen";
          break;

        case '/th/ais-dc/about/news':
        case '/en/ais-dc/about/news':
          title = "News ข่าวประชาสัมพันธ์ AIS D.C.";
          description = "อัพเดทข่าวประชาสัมพันธ์ AIS D.C.";
          keyword = "ข่าวสาร, ข่าวประสัมพันธ์ AIS D.C., ข่าวประสัมพันธ์ AIS D.C., ข่าวสาร AIS D.C.";
          break;

        case '/th/TCDC-COMMONS-MunMun-Srinakarin/about/news':
        case '/en/TCDC-COMMONS-MunMun-Srinakarin/about/news':
          title = "News ข่าวประชาสัมพันธ์ TCDC COMMONS MunMun Srinakarin";
          description = "อัพเดทข่าวประชาสัมพันธ์ TCDC COMMONS MunMun Srinakarin";
          keyword = "ข่าวสาร, ข่าวประสัมพันธ์ TCDC COMMONS MunMun Srinakarin, ข่าวประสัมพันธ์ TCDC COMMONS MunMun Srinakarin, ข่าวสาร TCDC COMMONS MunMun Srinakarin";
          break;

        case '/th/mini-tcdc/about/news':
        case '/en/mini-tcdc/about/news':
          title = "News ข่าวประชาสัมพันธ์ miniTCDC";
          description = "อัพเดทข่าวประชาสัมพันธ์ miniTCDC";
          keyword = "ข่าวสาร, ข่าวประสัมพันธ์ miniTCDC, ข่าวประสัมพันธ์ miniTCDC, ข่าวสาร miniTCDC";
          break;

        case '/th/tcdc-bangkok/service/venue-hire':
          title = "เช่าพื้นที่จัดกิจกรรม TCDC กรุงเทพฯ (Space Rentals)";
          description = "เช่าพื้นที่จัดนิทรรศการ โชว์เคส เช่าห้องประชุม ห้องสัมมนา กรุงเทพ ย่านเจริญกรุง บางรัก";
          keyword = "เช่าห้องประชุม, เช่าห้องสัมมนา, เช่าพื้นที่จัดนิทรรศการ กรุงเทพ, เช่าพื้นที่จัดแสดงดนตรี, เช่าห้องแกลลอรี่, เช่าห้องถ่ายโฆษณา, เช่าพื้นที่จัดโชว์เคส, เช่าพื้นที่ถ่ายภาพยนตร์ มิวสิกวิดีโอ, เช่าพื้นที่ rooftop, Rental Space, Creative Space, Meeting Room, Creative Space เจริญกรุง, เช่าพื้นที่จัดกิจกรรม, เช่าพื้นที่จัดประชุมสัมมนา, เช่าห้องประชุม เจริญกรุง, เช่าห้องสัมมนา เจริญกรุง,  เช่าห้องบรรยาย, เช่าห้องจัดกิจกรรม กรุงเทพ";
          break;
        case '/en/tcdc-bangkok/service/venue-hire':
          title = "Space rental services at TCDC Bangkok for creative activities.";
          description = "Spaces for rent include meeting rooms, spaces for exhibition, showcases, workshops, music performances at TCDC Bangkok, Charoenkrung Bangrak.";
          keyword = "Space for rent, meeting rooms, creative spaces, rooftop space, space for exhibition, workshops, space rentals in Bangkok, space rentals at Charoenkrung, space rentals at Bangrak";
          break;

        case '/th/tcdc-chiangmai/service/venue-hire':
        case '/en/tcdc-chiangmai/service/venue-hire':
          title = "เช่าพื้นที่ (Space Rentals) TCDC Chiangmai";
          description = "บริการเช่าพื้นที่ TCDC เชียงใหม่";
          keyword = "เช่าพื้นที่ TCDC, เช่าพื้นที่ TCDC เชียงใหม่, เช่าพื้นที่ TCDC Chiangmai, Space Rentals, Space Rentals TCDC Chiangmai, ติดต่อเช่าพื้นที่ TCDC เชียงใหม่";
          break;

        case '/th/tcdc-khonkaen/service/venue-hire':
        case '/en/tcdc-khonkaen/service/venue-hire':
          title = "เช่าพื้นที่ (Space Rentals) TCDC Khon Kaen";
          description = "บริการเช่าพื้นที่ TCDC ขอนแก่น";
          keyword = "เช่าพื้นที่ TCDC, เช่าพื้นที่ TCDC ขอนแก่น, เช่าพื้นที่ TCDC Khon Kaen, Space Rentals, Space Rentals TCDC Khon Kaen, ติดต่อเช่าพื้นที่, ติดต่อเช่าพื้นที่ TCDC ขอนแก่น";
          break;

        case '/th/ais-dc/service/venue-hire':
        case '/en/ais-dc/service/venue-hire':
          title = "เช่าพื้นที่ (Space Rentals) AIS D.C.";
          description = "บริการเช่าพื้นที่ AIS D.C.";
          keyword = "เช่าพื้นที่ AIS D.C., เช่าพื้นที่ AIS D.C., Space Rentals, Space Rentals TCDC AIS D.C., ติดต่อเช่าพื้นที่, ติดต่อเช่าพื้นที่ AIS D.C.";
          break;

        case '/th/all/service/membership':
        case '/en/all/service/membership':
          title = "สมาชิก TCDC";
          description = "TCDC แหล่งข้อมูลด้านการออกแบบและความคิดสร้างสรรค์ที่ใหญ่ที่สุดแห่งหนึ่งในเอเชีย ทรัพยากรสารสนเทศกว่า 70,000 รายการ";
          keyword = "สมาชิก TCDC, สมัครสมาชิก TCDC, สิทธิประโยชน์สมาชิก TCDC, อัตราสมาชิก TCDC, ค่าสมาชิก TCDC";
          break;

        case '/th/tcdc-bangkok/service/membership':
        case '/en/tcdc-bangkok/service/membership':
          title = "สมาชิก TCDC Bangkok";
          description = "TCDC แหล่งข้อมูลด้านการออกแบบและความคิดสร้างสรรค์ที่ใหญ่ที่สุดแห่งหนึ่งในเอเชีย ทรัพยากรสารสนเทศกว่า 70,000 รายการ";
          keyword = "สมาชิก TCDC กรุงเทพฯ, สมัครสมาชิก TCDC, สิทธิประโยชน์สมาชิก TCDC กรุงเทพฯ, อัตราสมาชิก TCDC กรุงเทพฯ, ค่าสมาชิก TCDC กรุงเทพฯ";
          break;

        case '/th/tcdc-chiangmai/service/membership':
        case '/en/tcdc-chiangmai/service/membership':
          title = "สมาชิก TCDC Chiangmai";
          description = "TCDC แหล่งข้อมูลด้านการออกแบบและความคิดสร้างสรรค์ที่ใหญ่ที่สุดแห่งหนึ่งในเอเชีย ทรัพยากรสารสนเทศกว่า 70,000 รายการ";
          keyword = "สมาชิก TCDC เชียงใหม่, สมัครสมาชิก TCDC เชียงใหม่, สิทธิประโยชน์สมาชิก TCDC เชียงใหม่, อัตราสมาชิก TCDC เขียงใหม่, ค่าสมาชิก TCDC เชียงใหม่";
          break;

        case '/th/tcdc-khonkaen/service/membership':
        case '/en/tcdc-khonkaen/service/membership':
          title = "สมาชิก TCDC Khon Kaen";
          description = "TCDC แหล่งข้อมูลด้านการออกแบบและความคิดสร้างสรรค์ที่ใหญ่ที่สุดแห่งหนึ่งในเอเชีย ทรัพยากรสารสนเทศกว่า 70,000 รายการ";
          keyword = "สมาชิก TCDC ขอนแก่น, สมัครสมาชิก TCDC ขอนแก่น, สิทธิประโยชน์สมาชิก TCDC, อัตราสมาชิก TCDC ขอนแก่น, ค่าสมาชิก TCDC ขอนแก่น";
          break;

        case '/th/ais-dc/service/membership':
        case '/en/ais-dc/service/membership':
          title = "สมาชิก AIS D.C.";
          description = "TCDC แหล่งข้อมูลด้านการออกแบบและความคิดสร้างสรรค์ที่ใหญ่ที่สุดแห่งหนึ่งในเอเชีย ทรัพยากรสารสนเทศกว่า 70,000 รายการ";
          keyword = "สมาชิก AIS D.C., สมัครสมาชิก AIS D.C., สิทธิประโยชน์สมาชิก AIS D.C., อัตราสมาชิก AIS D.C., ค่าสมาชิก AIS D.C.";
          break;

        case '/th/TCDC-COMMONS-MunMun-Srinakarin/service/membership':
        case '/en/TCDC-COMMONS-MunMun-Srinakarin/service/membership':
          title = "สมาชิก TCDC COMMONS Season Square";
          description = "TCDC แหล่งข้อมูลด้านการออกแบบและความคิดสร้างสรรค์ที่ใหญ่ที่สุดแห่งหนึ่งในเอเชีย ทรัพยากรสารสนเทศกว่า 70,000 รายการ";
          keyword = "สมาชิก TCDC COMMONS Season Square, สมัครสมาชิก TCDC COMMONS Season Square, สิทธิประโยชน์สมาชิก TCDC COMMONS Season Square, อัตราสมาชิก TCDC COMMONS Season Square, ค่าสมาชิก TCDC COMMONS Season Square";
          break;

        case '/th/our-service':
        case '/en/our-service':
          title = "Our Service คิด ผลิต ขาย ตอบโจทย์ธุรกิจสร้างสรรค์อย่างครบวงจรแห่งแรกในประเทศไทย";
          description = "TCDC ช่วยให้คุณค้นหาไอเดีย เปลี่ยนวิธีคิด ด้วยกระบวนการคิดเชิงออกแบบ (Design Thinking) การออกแบบบริการ (Service Design) และนวัตกรรมการออกแบบ (Design Innovation) เพื่อหาทางออกใหม่ให้กับธุรกิจ";
          keyword = "ความคิดสร้างสรรค์, ธุรกิจสร้างสรรค์, ไอเดียธุรกิจ, พัฒนาธุรกิจ, งานออกแบบ, ดีไซน์, เศรษฐกิจสร้างสรรค์, creative economy, นักสร้างสรรค์, ผู้ประกอบการสร้างสรรค์, Creative Economy, Creativity, Trend, Creative Startup, Business Startup, Service Design, Design Thinking";
          break;

        case '/th/tcdc-bangkok/service':
        case '/en/tcdc-bangkok/service':
          title = "TCDC Bangkok Service ส่วนงานบริการของ TCDC กรุงเทพฯ";
          description = "ข้อมูลการสมัครสมาชิก การเช่าพื้นที่ การเยี่ยมชมและพื้นที่ให้บริการ TCDC Bangkok แหล่งความรู้ด้านความคิดสร้างสรรค์ บทความ นิทรรศการออนไลน์";
          keyword = "เยี่ยมชม TCDC, การเดินทาง TCDC Bangkok, การเดินทาง TCDC เจริญกรุง, การเดินทาง TCDC กรุงเทพฯ, บริการของ TCDC, ข้อมูลการเยี่ยมชม TCDC, เวลาเปิด TCDC, เวลาเปิดทําการ TCDC, พื้นที่ให้บริการ TCDC กรุงเทพฯ, เช่าพื้นที่ TCDC, เช่าพื้นที่ TCDC กรุงเทพฯ, เช่าพื้นที่ TCDC Bangkok, บทความ, นิทรรศการออนไลน์";
          break;

        case '/th/tcdc-bangkok/service/visit-and-service-area':
        case '/en/tcdc-bangkok/service/visit-and-service-area':
          title = "Visit and Service Area เยี่ยมชมและพื้นที่ให้บริการ TCDC Bangkok";
          description = "TCDC Bangkok ข้อมูลการเยี่ยมชมและพื้นที่ให้บริการ การเดินทางมาที่ TCDC กรุงเทพฯ";
          keyword = "เยี่ยมชม TCDC Bangkok, การเดินทาง TCDC Bangkok, การเดินทาง TCDC เจริญกรุง, การเดินทาง TCDC กรุงเทพฯ, บริการของ TCDC กรุงเทพฯ, ข้อมูลการเยี่ยมชม TCDC กรุงเทพฯ, เวลาเปิด TCDC กรุงเทพฯ, พื้นที่ให้บริการ TCDC กรุงเทพฯ";
          break;

        case '/th/tcdc-chiangmai/service':
        case '/en/tcdc-chiangmai/service':
          title = "TCDC Chiangmai Service ส่วนงานบริการของ TCDC เชียงใหม่";
          description = "TCDC Chiangmai ข้อมูลการสมัครสมาชิก การเช่าพื้นที่ การเยี่ยมชมและพื้นที่ให้บริการ TCDC เชียงใหม่ แหล่งความรู้ด้านความคิดสร้างสรรค์ บทความ นิทรรศการออนไลน์";
          keyword = "เยี่ยมชม TCDC Chiangmai, การเดินทาง TCDC Chiangmai, การเดินทาง TCDC เชียงใหม่, บริการของ TCDC เชียงใหม่, ข้อมูลการเยี่ยมชม TCDC เชียงใหม่, เวลาเปิด TCDC เชียงใหม่, พื้นที่ให้บริการ TCDC เชียงใหม่, เช่าพื้นที่ TCDC เชียงใหม่, เช่าพื้นที่ TCDC Chiangmai, บทความ, นิทรรศการออนไลน์";
          break;

        case '/th/tcdc-chiangmai/service/visit-and-service-area':
        case '/en/tcdc-chiangmai/service/visit-and-service-area':
          title = "Visit and Service Area เยี่ยมชมและพื้นที่ให้บริการ TCDC Chiangmai";
          description = "ข้อมูลการเยี่ยมชมและพื้นที่ให้บริการ การเดินทางมาที่ TCDC เชียงใหม่";
          keyword = "เยี่ยมชม TCDC Chiangmai, การเดินทาง TCDC เชียงใหม่, การเดินทาง TCDC Chiangmai, บริการของ TCDC เชียงใหม่, ข้อมูลการเยี่ยมชม TCDC เชียงใหม่, เวลาเปิด TCDC เชียงใหม่, พื้นที่ให้บริการ TCDC เชียงใหม่";
          break;

        case '/th/tcdc-khonkaen/service':
        case '/en/tcdc-khonkaen/service':
          title = "TCDC Khon Kaen Service ส่วนงานบริการของ TCDC ขอนแก่น";
          description = "TCDC Khon Kaen ข้อมูลการสมัครสมาชิก การเช่าพื้นที่ การเยี่ยมชมและพื้นที่ให้บริการ TCDC ขอนแก่น แหล่งความรู้ด้านความคิดสร้างสรรค์ บทความ นิทรรศการออนไลน์";
          keyword = "เยี่ยมชม TCDC KHON KAEN, การเดินทาง TCDC KHON KAEN, การเดินทาง TCDC ขอนแก่น, บริการของ TCDC ขอนแก่น, ข้อมูลการเยี่ยมชม TCDC ขอนแก่น, เวลาเปิด TCDC ขอนแก่น, พื้นที่ให้บริการ TCDC ขอนแก่น, เช่าพื้นที่ TCDC ขอนแก่น, เช่าพื้นที่ TCDC KHON KAEN, บทความ, นิทรรศการออนไลน์";
          break;

        case '/th/tcdc-khonkaen/service/visit-and-service-area':
        case '/en/tcdc-khonkaen/service/visit-and-service-area':
          title = "Visit and Service Area เยี่ยมชมและพื้นที่ให้บริการ TCDC Khon Kaen";
          description = "ข้อมูลการเยี่ยมชมและพื้นที่ให้บริการ การเดินทางมาที่ TCDC ขอนแก่น";
          keyword = "เยี่ยมชม TCDC ขอนแก่น, การเดินทาง TCDC ขอนแก่น, การเดินทาง TCDC KHON KAEN, บริการของ TCDC ขอนแก่น, ข้อมูลการเยี่ยมชม TCDC ขอนแก่น, เวลาเปิด TCDC ขอนแก่น, พื้นที่ให้บริการ TCDC ขอนแก่น";
          break;

        case '/th/ais-dc/service':
        case '/en/ais-dc/service':
          title = "AIS D.C. Service ส่วนงานบริการของ AIS D.C.";
          description = "AIS D.C. ข้อมูลการสมัครสมาชิก การเช่าพื้นที่ การเยี่ยมชมและพื้นที่ให้บริการ AIS D.C. แหล่งความรู้ด้านความคิดสร้างสรรค์ บทความ นิทรรศการออนไลน์";
          keyword = "เยี่ยมชม AIS D.C., การเดินทาง AIS D.C., บริการของ AIS D.C., ข้อมูลการเยี่ยมชม AIS D.C., เวลาเปิด AIS D.C., พื้นที่ให้บริการ AIS D.C., เช่าพื้นที่ AIS D.C., บทความ, นิทรรศการออนไลน์";
          break;

        case '/th/ais-dc/service/visit-and-service-area':
        case '/en/ais-dc/service/visit-and-service-area':
          title = "Visit and Service Area เยี่ยมชมและพื้นที่ให้บริการ AIS D.C.";
          description = "ข้อมูลการเยี่ยมชมและพื้นที่ให้บริการ การเดินทางมาที่ AIS D.C.";
          keyword = "เยี่ยมชม AIS D.C., การเดินทาง AIS D.C., บริการของ AIS D.C., ข้อมูลการเยี่ยมชม AIS D.C., เวลาเปิด AIS D.C., พื้นที่ให้บริการ AIS D.C.";
          break;

        case '/th/TCDC-COMMONS-MunMun-Srinakarin/service':
        case '/en/TCDC-COMMONS-MunMun-Srinakarin/service':
          title = "ส่วนงานบริการของ TCDC COMMONS MunMun Srinakarin";
          description = "ข้อมูลการสมัครสมาชิก การเช่าพื้นที่ การเยี่ยมชมและพื้นที่ให้บริการ TCDC COMMONS MunMun Srinakarin แหล่งความรู้ด้านความคิดสร้างสรรค์ บทความ นิทรรศการออนไลน์";
          keyword = "เยี่ยมชม TCDC COMMONS MunMun Srinakarin, การเดินทาง TCDC COMMONS MunMun Srinakarin, บริการของ TCDC COMMONS MunMun Srinakarin, ข้อมูลการเยี่ยมชม TCDC COMMONS MunMun Srinakarin, เวลาเปิด TCDC COMMONS MunMun Srinakarin, พื้นที่ให้บริการ TCDC COMMONS MunMun Srinakarin, บทความ, นิทรรศการออนไลน์";
          break;

        case '/th/TCDC-COMMONS-MunMun-Srinakarin/service/visit-and-service-area':
        case '/en/TCDC-COMMONS-MunMun-Srinakarin/service/visit-and-service-area':
          title = "เยี่ยมชมและพื้นที่ให้บริการ TCDC COMMONS MunMun Srinakarin";
          description = "ข้อมูลการเยี่ยมชมและพื้นที่ให้บริการ การเดินทางมาที่ TCDC COMMONS MunMun Srinakarin";
          keyword = "เยี่ยมชม TCDC COMMONS MunMun Srinakarin, การเดินทาง TCDC COMMONS MunMun Srinakarin, บริการของ TCDC COMMONS MunMun Srinakarin, ข้อมูลการเยี่ยมชม TCDC COMMONS MunMun Srinakarin, เวลาเปิด TCDC COMMONS MunMun Srinakarin, เวลาปิด TCDC COMMONS MunMun Srinakarin, พื้นที่ให้บริการ TCDC COMMONS MunMun Srinakarin";
          break;

        case '/th/about-main':
        case '/en/about-main':
          title = "เกี่ยวกับ TCDC ศูนย์สร้างสรรค์การออกแบบ (Thailand Creative & Design Center)";
          description = "ศูนย์สร้างสรรค์การออกแบบ (TCDC) หน่วยงานภายใต้สํานักงานส่งเสริมเศรษฐกิจสร้างสรรค์ (องค์การมหาชน) หรือ Creative Economy Agency (CEA) พื้นที่แหล่งเรียนรู้ด้านการออกแบบและความคิดสร้างสรรค์ เป็นแหล่งบ่มเพาะธุรกิจสร้างสรรค์ และส่งเสริมให้เกิดการนําความคิดสร้างสรรค์ไปใช้ในการพัฒนาธุรกิจ พัฒนาสังคม และคุณภาพชีวิต";
          keyword = "สาขา TCDC, TCDC กรุงเทพฯ, TCDC Bangkok, TCDC Khon Kaen, TCDC ขอนแก่น, TCDC Chiangmai,TCDC เชียงใหม่, TCDC เจริญกรุง, AIS D.C., TCDC COMMONS, miniTCDC, ความคิดสร้างสรรค์, งานออกแบบ, ดีไซน์, เศรษฐกิจสร้างสรรค์, creative economy, นักสร้างสรรค์, ผู้ประกอบการสร้างสรรค์, พื้นที่สร้างสรรค์, Creativity, Trend, Creative City, Creative Startup, Service Design, Design Thinking";
          break;

        case '/th/tcdc-bangkok/about':
        case '/en/tcdc-bangkok/about':
          title = "รู้จัก TCDC Bangkok อาคารไปรษณีย์กลาง";
          description = "TCDC กรุงเทพฯ แหล่งบ่มเพาะธุรกิจสร้างสรรค์และส่งเสริมให้เกิดการนําความคิดสร้างสรรค์ไปใช้ในการพัฒนาธุรกิจ พัฒนาสังคม และคุณภาพชีวิต เพื่อขับเคลื่อนเศรษฐกิจสร้างสรรค์ของประเทศไทย";
          keyword = "TCDC Bangkok, TCDC กรุงเทพฯ, TCDC เจริญกรุง, ติดต่อ TCDC, Contact TCDC, ความคิดสร้างสรรค์, พัฒนาธุรกิจสร้างสรรค์, ธุรกิจสร้างสรรค์, การออกแบบ, ดีไซน์, เศรษฐกิจสร้างสรรค์, creative economy, Creativity, Creative Startup";
          break;

        case '/th/tcdc-chiangmai/about':
        case '/en/tcdc-chiangmai/about':
          title = "รู้จัก TCDC Chiangmai";
          description = "TCDC เชียงใหม่ ศูนย์กลางความรู้ด้านการออกแบบและบ่มเพาะความคิดสร้างสรรค์ครบวงจรแห่งแรกในพื้นที่ภาคเหนือตอนบน";
          keyword = "TCDC Chiangmai, TCDC เชียงใหม่, ติดต่อ TCDC เชียงใหม่, Contact TCDC, ความคิดสร้างสรรค์, พัฒนาธุรกิจสร้างสรรค์, ธุรกิจสร้างสรรค์, การออกแบบ, ดีไซน์, เศรษฐกิจสร้างสรรค์, creative economy, Creativity, Creative Startup";
          break;

        case '/th/tcdc-khonkaen/about':
        case '/en/tcdc-khonkaen/about':
          title = "รู้จัก TCDC Khon Kaen";
          description = "TCDC ขอนแก่น ศูนย์ความรู้ด้านการออกแบบและความคิด สร้างสรรค์แห่งภาคอีสาน (Center of Isan – Design Knowledge and Information)";
          keyword = "TCDC Khon Kaen, TCDC ขอนแก่น, ติดต่อ TCDC ขอนแก่น, Contact TCDC Khon Kaen, ศูนย์นวัตกรรมวัสดุอีสาน, Isan Material Center, พัฒนาธุรกิจสร้างสรรค์, ความคิดสร้างสรรค์, ความคิดสร้างสรรค์, ธุรกิจสร้างสรรค์, การออกแบบ, ดีไซน์, เศรษฐกิจสร้างสรรค์, creative economy, Creativity, Creative Startup";
          break;

        case '/th/ais-dc/about':
        case '/en/ais-dc/about':
          title = "รู้จัก AIS D.C.";
          description = "AIS Design Centre (AIS D.C.) พื้นที่บริการความรู้ด้านการออกแบบและความคิดสร้างสรรค์ให้กับคนรุ่นใหม่ สตาร์ทอัพ และผู้ประกอบการสร้างสรรค์";
          keyword = "AIS D.C., ติดต่อ AIS D.C., พัฒนาธุรกิจสร้างสรรค์, ความคิดสร้างสรรค์, ธุรกิจสร้างสรรค์, การออกแบบ, ดีไซน์, เศรษฐกิจสร้างสรรค์, creative economy, Creativity, Creative Startup";
          break;

        case '/th/mini-tcdc/about/mini-tcdc':
        case '/en/mini-tcdc/about/mini-tcdc':
          title = "รู้จัก miniTCDC แหล่งความรู้ด้านการออกแบบ...ใกล้ตัวคุณ";
          description = "miniTCDC หรือโครงการกระจายโอกาสสร้างแหล่งเรียนรู้ด้านการออกแบบสู่ภูมิภาค เพื่อส่งเสริมการใช้กระบวนการคิดเชิงออกแบบในการพัฒนาคุณภาพชีวิตของคนในชุมชนและผลักดันธุรกิจสร้างสรรค์ในท้องถิ่น";
          keyword = "miniTCDC, ติดต่อ miniTCDC, บริการ miniTCDC, เครือข่าย miniTCDC, TCDC Center, TCDC Link, ความคิดสร้างสรรค์, กิจกรรมความคิดสร้างสรรค์, ธุรกิจสร้างสรรค์, การออกแบบ, ดีไซน์, เศรษฐกิจสร้างสรรค์, creative economy, Creativity, Creative Startup";
          break;

        case '/th/all/service/resource-center/tcdc-resource-center':
        case '/en/all/service/resource-center/tcdc-resource-center':
        case '/th/tcdc-bangkok/service/resource-center/tcdc-resource-center':
        case '/en/tcdc-bangkok/service/resource-center/tcdc-resource-center':
        case '/th/tcdc-chiangmai/service/resource-center/tcdc-resource-center':
        case '/en/tcdc-chiangmai/service/resource-center/tcdc-resource-center':
        case '/th/tcdc-khonkaen/service/resource-center/tcdc-resource-center':
        case '/en/tcdc-khonkaen/service/resource-center/tcdc-resource-center':
        case '/th/ais-dc/service/resource-center/tcdc-resource-center':
        case '/en/ais-dc/service/resource-center/tcdc-resource-center':
        case '/th/TCDC-COMMONS-MunMun-Srinakarin/service/resource-center/tcdc-resource-center':
        case '/en/TCDC-COMMONS-MunMun-Srinakarin/service/resource-center/tcdc-resource-center':
        case '/th/mini-tcdc/service/resource-center/tcdc-resource-center':
        case '/en/mini-tcdc/service/resource-center/tcdc-resource-center':
          title = "TCDC Resource Center พื้นที่ต่อยอดความคิดสร้างสรรค์ แหล่งข้อมูลด้านการออกแบบและความคิดสร้างสรรค์ที่ใหญ่ที่สุดแห่งหนึ่งในเอเชีย";
          description = "TCDC Resource Center คือศูนย์กลางการเรียนรู้และแหล่งค้นคว้าข้อมูลด้านการออกแบบและความคิดสร้างสรรค์สําหรับนักออกแบบ นักศึกษา ผู้ประกอบการ และประชาชนทั่วไป";
          keyword = "TCDC Resource Center, ห้องสมุด TCDC, TCDC library, ข้อมูลด้านการออกแบบ, ความคิดสร้างสรรค์, ธุรกิจสร้างสรรค์, ไอเดียธุรกิจ, พัฒนาธุรกิจ, งานออกแบบ, ดีไซน์, เศรษฐกิจสร้างสรรค์, creative economy, นักสร้างสรรค์, ผู้ประกอบการสร้างสรรค์, Creative Economy, Creativity, Creative Startup, Business Startup, Service Design, Design Thinking";
          break;

        case '/th/all/service/resource-center/material':
        case '/en/all/service/resource-center/material':
        case '/th/tcdc-bangkok/service/resource-center/material':
        case '/en/tcdc-bangkok/service/resource-center/material':
        case '/th/tcdc-chiangmai/service/resource-center/material':
        case '/en/tcdc-chiangmai/service/resource-center/material':
        case '/th/tcdc-khonkaen/service/resource-center/material':
        case '/en/tcdc-khonkaen/service/resource-center/material':
        case '/th/ais-dc/service/resource-center/material':
        case '/en/ais-dc/service/resource-center/material':
        case '/th/TCDC-COMMONS-MunMun-Srinakarin/service/resource-center/material':
        case '/en/TCDC-COMMONS-MunMun-Srinakarin/service/resource-center/material':
        case '/th/mini-tcdc/service/resource-center/material':
        case '/en/mini-tcdc/service/resource-center/material':
          title = "Material & Design Innovation Center ศูนย์นวัตกรรมด้านวัสดุและการออกแบบ";
          description = "Material & Design Innovation Center ส่งเสริมและสนับสนุนนวัตกรรมด้านวัสดุและการออกแบบ พัฒนาความคิด สร้างโอกาสทางธุรกิจ และเชื่อมเครือข่ายผู้ประกอบการ";
          keyword = "Material & Design Innovation Center, MDIC, Design, Material, Innovation, Trend, เทรนด์วัสดุ, Material ConneXion® Bangkok, ย่านวัสดุ, วัสดุไทย, วัสดุภูมิภาค, ข้อมูลวัสดุ, นวัตกรรมวัสดุ, ธุรกิจสร้างสรรค์, ไอเดียธุรกิจ, พัฒนาธุรกิจ, งานออกแบบ, ดีไซน์, เศรษฐกิจสร้างสรรค์, creative economy, นักสร้างสรรค์, ผู้ประกอบการสร้างสรรค์, Creative Economy, Creativity, Creative Startup, Business Startup";
          break;

        case '/th/all/service/resource-center/database':
        case '/en/all/service/resource-center/database':
        case '/th/tcdc-bangkok/service/resource-center/database':
        case '/en/tcdc-bangkok/service/resource-center/database':
        case '/th/tcdc-chiangmai/service/resource-center/database':
        case '/en/tcdc-chiangmai/service/resource-center/database':
        case '/th/tcdc-khonkaen/service/resource-center/database':
        case '/en/tcdc-khonkaen/service/resource-center/database':
        case '/th/ais-dc/service/resource-center/database':
        case '/en/ais-dc/service/resource-center/database':
        case '/th/TCDC-COMMONS-MunMun-Srinakarin/service/resource-center/database':
        case '/en/TCDC-COMMONS-MunMun-Srinakarin/service/resource-center/database':
        case '/th/mini-tcdc/service/resource-center/database':
        case '/en/mini-tcdc/service/resource-center/database':
          title = "TCDC Database ฐานข้อมูลออนไลน์";
          description = "TCDC Database ฐานข้อมูลออนไลน์ส่งเสริมและสนับสนุนข้อมูลการออกแบบ ธุรกิจสร้างสรรค์ แนวโน้มอุตสาหกรรมสร้างสรรค์ และนวัตกรรมวัสดุ เพื่อสร้างโอกาสทางธุรกิจ";
          keyword = "ฐานข้อมูลออนไลน์, TCDC Database, Passport GMID, ข้อมูลด้านธุรกิจแฟชั่น ข้อมูลการตลาด ข้อมูลดิจิทัลมีเดีย, WGSN, ข้อมูลแนวโน้มอุตสาหกรรมแฟชั่น, STASH, Material ConneXion® Bangkok, Material ConneXion, ข้อมูลวัสดุ, ข้อมูลนวัตกรรมวัสดุ, ธุรกิจสร้างสรรค์, ไอเดียธุรกิจ, พัฒนาธุรกิจ, งานออกแบบ, ดีไซน์, เศรษฐกิจสร้างสรรค์, creative economy, นักสร้างสรรค์, ผู้ประกอบการสร้างสรรค์";
          break;

        case '/th/home/tcdc-bangkok':
        case '/en/home/tcdc-bangkok':
        case '/th/home/tcdc-chiangmai':
        case '/en/home/tcdc-chiangmai':
        case '/th/home/tcdc-khonkaen':
        case '/en/home/tcdc-khonkaen':
        case '/th/home/ais-dc':
        case '/en/home/ais-dc':
        case '/th/home/TCDC-COMMONS-MunMun-Srinakarin':
        case '/en/home/TCDC-COMMONS-MunMun-Srinakarin':
        case '/th/home/mini-tcdc':
        case '/en/home/mini-tcdc':
          title = "TCDC Program กิจกรรมและนิทรรศการ";
          description = "TCDC จัดกิจกรรม เวิร์กชอป นิทรรศการ อีเวนต์ ส่งเสริมให้เกิดความคิดสร้างสรรค์ ช่วยค้นหาไอเดีย เปลี่ยนวิธีคิด เพื่อหาทางออกใหม่ให้กับธุรกิจ";
          keyword = "TCDC Exhibition, TCDC workshop, TCDC Seminar, ความคิดสร้างสรรค์, พัฒนาธุรกิจสร้างสรรค์, นิทรรศการ, กิจกรรม, ธุรกิจสร้างสรรค์, ไอเดียธุรกิจ, พัฒนาธุรกิจ, งานออกแบบ, ดีไซน์, เศรษฐกิจสร้างสรรค์, creative economy, นักสร้างสรรค์, ผู้ประกอบการสร้างสรรค์, Creative Economy, Creativity, Creative Startup, Business Startup, Service Design, Design Thinking";
          break;

        case '/th/enewsletter':
        case '/en/enewsletter':
          title = "E-Newsletter รับข่าวสาร TCDC";
          description = "ขอรับข่าวสารจาก TCDC (Subscribe TCDC e-newsletter)";
          keyword = "ข่าวสาร TCDC, TCDC E-news";
          break;

      }

      setMetaTags(document, window, title, description, defaultImage, keyword)

    }
  }
};
</script>

<style>
.header-space-tcdc {
  padding-top: 70px;
}
</style>
